import React from 'react';
import { Alert, Button, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
export default function AdminCreate() {
  const navigate = useNavigate();
  return <Card title="开通学校管理员"><Alert showIcon type="info" message="请先选择已有标准学校" description="在学校的管理员设置中记录负责人核验，再授权本校教师或新建独立账号，由负责人本人设置登录信息。" /><Button type="primary" style={{ marginTop: 20 }} onClick={() => navigate('/schools')}>选择学校并开通</Button></Card>;
}
